import axios from 'axios'
import router from '@builder-web/Routes'

const SET_THREADS = 'SET_THREADS'
/**
 * Vuex state for chat module
 * @type {Object}
 */
const state = {
    threads: [],
}

/**
 * Vuex mutations for chat module
 * @type {Object}
 */
const mutations = {
    [SET_THREADS]: (state, payload) => {
        state.threads = payload
    }
}

/**
 * Vuex actions for job module
 * @type {Object}
 */
const actions = {
    async fetchThreads({ dispatch }) {
        const { data } = await axios.get('/api/conversations')
        dispatch('setThreads', data.data)
    },

    async makeConversation({ dispatch }, { id }) {
        const { data } = await axios
            .post('/api/conversations', {
                recipient_id: id
            })
        dispatch('fetchThreads')
        router.push({ name: 'messages.chat.show', params: { uuid: data.data.uuid } })
        return data
    },

    setThreads({ commit }, threads) {
        commit(SET_THREADS, threads)
    },
}

/**
 * Vuex getters for chat module
 * @type {Object}
 */
const getters = {
    threads: state => state.threads,

    starred: state => (
        state.threads.filter(e => e.is_starred)
    ),

    undeleted: state => (
        state.threads.filter(e => !e.is_deleted)
    ),

    unreadThreads: state => state.threads.filter(e => e.unread_messages_count > 0)
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
